/**
 * FlightIcon — a top-down aircraft silhouette intended to replace the casual
 * `lucide-react/Plane` icon across the flight voucher and itinerary surfaces.
 *
 * The shape is a single closed path tuned for a 24×24 viewBox:
 *   - Pointed nose cone at top.
 *   - Slightly tapered fuselage running vertically.
 *   - Wide delta-style wing sweep at the mid-section (max x-extent ±9.3
 *     from centre — wider than the Lucide Plane).
 *   - Twin horizontal stabilisers + slight tail rake at the bottom.
 *
 * Renders crisply at any size because every coordinate is on a half-pixel
 * grid relative to the viewBox; downstream callers should pass equal
 * width/height to avoid distortion.
 *
 * Props:
 *   width / height  — accepts px number or any valid CSS length (default 24).
 *   color           — fill colour (default 'currentColor' so the icon
 *                     inherits the surrounding text colour).
 *   strokeWidth     — optional outline. Default 0 (fill-only silhouette).
 *   className       — passthrough for Tailwind utility classes if needed.
 *   ...rest         — any other valid <svg> attributes.
 */
import React from 'react';

export default function FlightIcon({
  width = 24,
  height = 24,
  color = 'currentColor',
  strokeWidth = 0,
  className = '',
  ...rest
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path
        d="M12 1.5 L13 3.2 L13 9.5 L22.5 12.5 L22.5 13.5 L13 11.8 L13 17.5 L16.2 19.5 L16.2 20.5 L12 19.2 L7.8 20.5 L7.8 19.5 L11 17.5 L11 11.8 L1.5 13.5 L1.5 12.5 L11 9.5 L11 3.2 Z"
        fill={color}
        stroke={strokeWidth ? color : 'none'}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
